import React from 'react';

import { useIntl } from 'react-intl';

import { useCashierShow } from '@/features/cashier/useCashier';
import { ButtonWithLoader } from '@/components/Common/ButtonWithLoader';

const CashierButton = ({ promoCode }: { promoCode: string }) => {
  const showCashier = useCashierShow();
  const intl = useIntl();

  const openCashierHandler = () => {
    showCashier({ bonusCode: promoCode });
  };

  return (
    // TODO: change this button into normal button without loader once we make a theme of reusable buttons
    <ButtonWithLoader
      message={intl.formatMessage({ id: 'misc.depositNow' })}
      onClick={openCashierHandler}
      loading={false}
      className="bg-emerald-500 hover:bg-emerald-600 !my-0 !text-base h-auto py-4 px-6"
      dataCy="bonus-card-deposit-button"
    />
  );
};

export default CashierButton;
